import React, { useState, useEffect, useRef } from "react";
import db from "./Firebase";
import { firebase, auth } from './Firebase';
import { collection, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import axios from "axios";
import { useNavigate, Link, useParams } from "react-router-dom";


function PortfolioPage() {
    let params = useParams();
    const [selectedOption, setSelectedOption] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true)
    const [certificateCount, setCertificateCount] = useState(0);
    const [personalData, setPersonalData] = useState({});
    const [personalService, setPersonalService] = useState({});
    const [colorData, setColorData] = useState({});
    const [color, setcolor] = useState("white")
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [testimonials, setTestimonials] = useState([]);

    const [edata, setEdata] = useState([]);
    const [rating, setRating] = useState(0);
    const [ind, setInd] = useState(null);
    const initialFormStateFeedback = { email: '', password: '', created_date: new Date() }
    const [submit, setSubmit] = useState(initialFormStateFeedback);
    const initialFormStateEnquiry = { name: '', phone_no: '', message: '', service: '', username: '', created_date: new Date() }
    const [submitEnquiry, setSubmitEnquiry] = useState(initialFormStateEnquiry);
    const [serviceName, setServiceName] = useState('');
    const [serviceCategory, setServiceCategory] = useState('');
    const [amount, setAmount] = useState('');

    const [isVerified, setIsVerified] = useState(false);
    const [verifiedPhoneNo, setVerifiedPhoneNo] = useState("");
    const [verifiedName, setVerifiedName] = useState("");

    const galleryRef = useRef(null);
    const [usernames, setUsernames] = useState([]);

    const [currentDate, setCurrentDate] = useState('');
    useEffect(() => {
        const fetchPortfolioAndCertificates = async () => {
            try {
                // Step 1: Fetch Portfolio Data
                const q = query(
                    collection(db, "nv_portfolio_details"),
                    where("username", "==", params.id.toLowerCase())
                );

                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const portfolioData = querySnapshot.docs[0].data();
                    setPersonalData(portfolioData);

                    // Step 2: Fetch Certificate Count using phone_no
                    if (portfolioData.phone_no) {
                        const certQuery = query(
                            collection(db, "nv_certificates"),
                            where("phone_no", "==", portfolioData.phone_no)
                        );

                        const certSnapshot = await getDocs(certQuery);
                        setCertificateCount(certSnapshot.size); // Number of documents found
                    }
                } else {
                    console.error("No portfolio found!");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPortfolioAndCertificates();

        const formattedDate = moment().format('YYYY-MM-DD[T]HH:mm');
        setCurrentDate(formattedDate);
        db.collection("portfolio_details").where('username', '==', params.id.toLowerCase()).onSnapshot((snapshot) => {
            // alert("personal_details calling")
            // setCustomersData(
            //     snapshot.docs.map((doc) => ({
            //         id: doc.id,
            //         data: doc.data(),
            //     }))
            // );
            snapshot.docs.map(e => setPersonalService(e.data()))
            if (snapshot.docs.length == 0) {
                navigate('/error');
            } else {
                // alert("exists")
                setIsLoading(false);
            }
        });



        db.collection("website_color_code").where('username', '==', params.id.toLowerCase()).onSnapshot((snapshot) => {
            snapshot.docs.map(e => setColorData(e.data()))
            if (snapshot.docs.length == 0) {
                // navigate('/error');
            } else {
                // alert("exists")
                // setIsLoading(false);
                // alert(colorData.color_code)
                if (colorData.color_code === "white") {
                    setcolor("white")
                } else if (colorData.color_code === "black") {
                    setcolor("black")
                }
                else if (colorData.color_code === "perl") {
                    setcolor("#fefbe9")
                }
                else if (colorData.color_code === "blossom") {
                    setcolor("#ffb7c5")
                }
                else if (colorData.color_code === "lime") {
                    setcolor("#c3fd38")
                }
                else if (colorData.color_code === "lavender") {
                    setcolor("#e6e6fa")
                }
                else if (colorData.color_code === "sunbeam") {
                    setcolor("#ffefd5")
                }
                else if (colorData.color_code === "fresh") {
                    setcolor("#bdfcc9")
                }
                else if (colorData.color_code === "glow") {
                    setcolor("#f0e6f0")
                }
                else if (colorData.color_code === "quartz") {
                    setcolor("#f7cac9")
                }
                else if (colorData.color_code === "violet") {
                    setcolor("#b673b0")
                } else {
                    setcolor("white")
                }
            }
        });

        db.collection("parlour_feedback")
            .where("username", "==", params.id.toLowerCase())
            .orderBy("created_date", "desc")
            .onSnapshot((snapshot) => {
                const feedback = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                    initials: doc.data().name
                        ? doc.data().name
                            .split(" ")
                            .map((n) => n[0])
                            .join("")
                            .toUpperCase()
                        : "U",
                }));
                setTestimonials(feedback);
            });




        // var yourRatingData = [];
        db.collection("parlour_feedback").where('username', '==', params.id.toLowerCase()).orderBy("created_date", "desc").onSnapshot((snapshot) => {
            let _5star = snapshot.docs.filter(r => r.data().rating == 5).length;
            let _4star = snapshot.docs.filter(r => r.data().rating == 4).length;
            let _3star = snapshot.docs.filter(r => r.data().rating == 3).length;
            let _2star = snapshot.docs.filter(r => r.data().rating == 2).length;
            let _1star = snapshot.docs.filter(r => r.data().rating == 1).length;

            let sumOfRating = parseInt(_5star + _4star + _3star + _2star + _1star);
            let overallRating = parseInt(5 * _5star + 4 * _4star + 3 * _3star + 2 * _2star + 1 * _1star);
            let averageRating = parseFloat(overallRating / sumOfRating);
            // console.log(averageRating.toFixed(1));
            setRating(averageRating.toFixed(1))
            snapshot.docs.map((e) => {
                // console.log(e.data())

                var data1 = {
                    "name": e.data().full_name,
                    "position": "",
                    "photo": e.data().image,
                    "text": e.data().review,

                };

                edata.push(data1);
                // alert("1")S
                // testi();
                // alert(data)
            })
        });


        // const slides = document.querySelector('.slides');
        // const dot = document.querySelector('.dot');
        // // have access to it
    }, []);

    // useEffect(() => {
    //     const servicesCarousel = document.querySelector(".services-carousel");
    //     const leftBtnS = document.querySelector(".services-btn.left");
    //     const rightBtnS = document.querySelector(".services-btn.right");

    //     if (!servicesCarousel || !leftBtnS || !rightBtnS) return;

    //     const getCardWidth = () => {
    //         const card = document.querySelector(".service-card");
    //         return card ? card.offsetWidth + 24 : 300;
    //     };

    //     const updateServiceBtnStates = () => {
    //         const maxScrollLeft = servicesCarousel.scrollWidth - servicesCarousel.clientWidth;
    //         leftBtnS.classList.toggle("disabled", servicesCarousel.scrollLeft == 0);
    //         rightBtnS.classList.toggle("disabled", servicesCarousel.scrollLeft == maxScrollLeft - 5);
    //     };

    //     const scrollLeft = () => servicesCarousel.scrollBy({ left: -getCardWidth(), behavior: "smooth" });
    //     const scrollRight = () => servicesCarousel.scrollBy({ left: getCardWidth(), behavior: "smooth" });

    //     leftBtnS.addEventListener("click", scrollLeft);
    //     rightBtnS.addEventListener("click", scrollRight);
    //     servicesCarousel.addEventListener("scroll", updateServiceBtnStates);

    //     updateServiceBtnStates();

    //     // Cleanup on unmount
    //     return () => {
    //         leftBtnS.removeEventListener("click", scrollLeft);
    //         rightBtnS.removeEventListener("click", scrollRight);
    //         servicesCarousel.removeEventListener("scroll", updateServiceBtnStates);
    //     };
    // }, []);

    useEffect(() => {
        const servicesCarousel = document.querySelector(".services-carousel");
        const leftBtnS = document.querySelector(".services-btn.left");
        const rightBtnS = document.querySelector(".services-btn.right");
        const cards = document.querySelectorAll(".service-card");

        if (!servicesCarousel || !leftBtnS || !rightBtnS) return;

        // Show/hide based on actual cards count
        if (cards.length <= 3) {
            leftBtnS.style.display = "none";
            rightBtnS.style.display = "none";
            return;
        } else {
            leftBtnS.style.display = "block";
            rightBtnS.style.display = "block";
        }

        const getCardWidth = () => {
            const card = document.querySelector(".service-card");
            return card ? card.offsetWidth + 24 : 300;
        };

        const updateServiceBtnStates = () => {
            const maxScrollLeft = servicesCarousel.scrollWidth - servicesCarousel.clientWidth;
            leftBtnS.classList.toggle("disabled", servicesCarousel.scrollLeft === 0);
            rightBtnS.classList.toggle("disabled", servicesCarousel.scrollLeft >= maxScrollLeft - 5);
        };

        const scrollLeft = () => servicesCarousel.scrollBy({ left: -getCardWidth(), behavior: "smooth" });
        const scrollRight = () => servicesCarousel.scrollBy({ left: getCardWidth(), behavior: "smooth" });

        leftBtnS.addEventListener("click", scrollLeft);
        rightBtnS.addEventListener("click", scrollRight);
        servicesCarousel.addEventListener("scroll", updateServiceBtnStates);

        updateServiceBtnStates();

        return () => {
            leftBtnS.removeEventListener("click", scrollLeft);
            rightBtnS.removeEventListener("click", scrollRight);
            servicesCarousel.removeEventListener("scroll", updateServiceBtnStates);
        };
    }, [personalService?.services]);  // depend on the services array




    // useEffect(() => {
    //     const galleryTrack = document.querySelector(".gallery-track");
    //     const leftBtn = document.querySelector(".gallery-btn.left");
    //     const rightBtn = document.querySelector(".gallery-btn.right");

    //     if (!galleryTrack || !leftBtn || !rightBtn) return;

    //     const cardWidth = () => {
    //         const card = document.querySelector(".g-card");
    //         return card ? card.offsetWidth + 24 : 300; // include gap
    //     };

    //     const updateButtonStates = () => {
    //         const maxScrollLeft = galleryTrack.scrollWidth - galleryTrack.clientWidth;
    //         leftBtn.classList.toggle("disabled", galleryTrack.scrollLeft == 0);
    //         rightBtn.classList.toggle("disabled", galleryTrack.scrollLeft == maxScrollLeft - 5);
    //     };

    //     const scrollLeft = () => {
    //         galleryTrack.scrollBy({ left: -cardWidth(), behavior: "smooth" });
    //     };

    //     const scrollRight = () => {
    //         galleryTrack.scrollBy({ left: cardWidth(), behavior: "smooth" });
    //     };

    //     leftBtn.addEventListener("click", scrollLeft);
    //     rightBtn.addEventListener("click", scrollRight);
    //     galleryTrack.addEventListener("scroll", updateButtonStates);

    //     // Initial state on mount
    //     updateButtonStates();

    //     return () => {
    //         leftBtn.removeEventListener("click", scrollLeft);
    //         rightBtn.removeEventListener("click", scrollRight);
    //         galleryTrack.removeEventListener("scroll", updateButtonStates);
    //     };
    // }, []);


    useEffect(() => {
        const galleryTrack = document.querySelector(".gallery-track");
        const leftBtn = document.querySelector(".gallery-btn.left");
        const rightBtn = document.querySelector(".gallery-btn.right");
        const cards = document.querySelectorAll(".g-card");

        if (!galleryTrack || !leftBtn || !rightBtn) return;

        // Show/hide buttons based on card count
        if (cards.length <= 3) {
            leftBtn.style.display = "none";
            rightBtn.style.display = "none";
            return;
        } else {
            leftBtn.style.display = "block";
            rightBtn.style.display = "block";
        }

        const cardWidth = () => {
            const card = document.querySelector(".g-card");
            return card ? card.offsetWidth + 24 : 300; // include spacing
        };

        const updateButtonStates = () => {
            const maxScrollLeft = galleryTrack.scrollWidth - galleryTrack.clientWidth;
            leftBtn.classList.toggle("disabled", galleryTrack.scrollLeft === 0);
            rightBtn.classList.toggle("disabled", galleryTrack.scrollLeft >= maxScrollLeft - 5);
        };

        const scrollLeft = () => galleryTrack.scrollBy({ left: -cardWidth(), behavior: "smooth" });
        const scrollRight = () => galleryTrack.scrollBy({ left: cardWidth(), behavior: "smooth" });

        leftBtn.addEventListener("click", scrollLeft);
        rightBtn.addEventListener("click", scrollRight);
        galleryTrack.addEventListener("scroll", updateButtonStates);

        updateButtonStates();

        return () => {
            leftBtn.removeEventListener("click", scrollLeft);
            rightBtn.removeEventListener("click", scrollRight);
            galleryTrack.removeEventListener("scroll", updateButtonStates);
        };
    }, [personalData?.gallery]); // ✅ Add your gallery data state/prop here if dynamic





    useEffect(() => {
        let current = 0;

        const avatar = document.getElementById("rAvatar");
        const nameEl = document.getElementById("rName");
        const phoneEl = document.getElementById("rPhone");
        const starsEl = document.getElementById("rStars");
        const textEl = document.getElementById("rText");

        const prevBtn = document.getElementById("prevBtn");
        const nextBtn = document.getElementById("nextBtn");

        if (!avatar || !nameEl || !phoneEl || !starsEl || !textEl || !prevBtn || !nextBtn) return;

        const renderTestimonial = (index) => {
            if (!testimonials || testimonials.length === 0) {
                avatar.textContent = "NA";
                nameEl.textContent = "No Feedback Yet";
                phoneEl.textContent = "";
                textEl.textContent = "There are no customer reviews available at the moment.";
                starsEl.innerHTML = "";
                for (let i = 1; i <= 5; i++) {
                    const star = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    star.setAttribute("width", "22");
                    star.setAttribute("height", "22");
                    star.setAttribute("viewBox", "0 0 24 24");
                    star.innerHTML = `<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>`;
                    star.setAttribute("fill", "rgba(255,255,255,0.25)");
                    starsEl.appendChild(star);
                }

                prevBtn.classList.add("disabled");
                nextBtn.classList.add("disabled");
                return;
            }

            const t = testimonials[index];
            avatar.textContent = t.initials || t.name?.charAt(0).toUpperCase() || "U";
            nameEl.textContent = t.full_name || "Anonymous";
            phoneEl.textContent = t.phone_no || "";
            textEl.textContent = t.review || "";

            starsEl.innerHTML = "";
            for (let i = 1; i <= 5; i++) {
                const star = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                star.setAttribute("width", "22");
                star.setAttribute("height", "22");
                star.setAttribute("viewBox", "0 0 24 24");
                star.innerHTML = `<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>`;
                star.setAttribute("fill", i <= (t.rating || 0) ? "#FED369" : "rgba(255,255,255,0.55)");
                starsEl.appendChild(star);
            }

            prevBtn.classList.toggle("disabled", index === 0);
            nextBtn.classList.toggle("disabled", index === testimonials.length - 1);
        };

        const handleNext = () => {
            if (current < testimonials.length - 1) {
                current++;
                renderTestimonial(current);
            }
        };

        const handlePrev = () => {
            if (current > 0) {
                current--;
                renderTestimonial(current);
            }
        };

        nextBtn.addEventListener("click", handleNext);
        prevBtn.addEventListener("click", handlePrev);

        // Only render if testimonials exist
        renderTestimonial(current);

        return () => {
            nextBtn.removeEventListener("click", handleNext);
            prevBtn.removeEventListener("click", handlePrev);
        };
    }, [testimonials]); // 👈 Add as dependency



    useEffect(() => {
        const menuToggle = document.getElementById("menuToggle");
        const mainNav = document.getElementById("mainNav");

        if (!menuToggle || !mainNav) return;

        const handleToggle = () => {
            menuToggle.classList.toggle("active");
            mainNav.classList.toggle("show");
        };

        const handleLinkClick = () => {
            mainNav.classList.remove("show");
            menuToggle.classList.remove("active");
        };

        menuToggle.addEventListener("click", handleToggle);

        const navLinks = document.querySelectorAll(".pill-nav a");
        navLinks.forEach((link) => link.addEventListener("click", handleLinkClick));

        return () => {
            menuToggle.removeEventListener("click", handleToggle);
            navLinks.forEach((link) => link.removeEventListener("click", handleLinkClick));
        };
    }, []);

    // Helpers (put above return)
    const isVideoUrl = (url = "") => /\.(mp4|webm|ogg)(\?|#|$)/i.test(url);
    const isImageUrl = (url = "") => /\.(jpe?g|png|gif|webp|svg)(\?|#|$)/i.test(url);

    const pickMedia = (item = {}) => {
        const img =
            item?.image_url || item?.image || item?.img || item?.url || "";
        const vid =
            item?.video_url || item?.video || "";

        // 1) Prefer explicit image if present
        if (img) return { type: "image", src: img };

        // 2) If no image but video present AND looks like video
        if (vid && isVideoUrl(vid)) return { type: "video", src: vid };

        // 3) If only one URL present but unknown extension, try image first
        if (vid && !isVideoUrl(vid)) return { type: "image", src: vid };

        return { type: "none", src: "" };
    };

    // const MediaThumb = ({ item, boxStyle }) => {
    //     const { type, src } = pickMedia(item);
    //     if (type === "video")
    //         return <video src={src} controls style={boxStyle} />;
    //     if (type === "image")
    //         return <img src={src} alt="Gallery" style={boxStyle} onError={(e) => { e.currentTarget.style.display = 'none'; }} />;
    //     return null;
    // };



    const MediaThumb = ({ item, boxStyle }) => {
        const { type, src } = pickMedia(item);
        const handleOpenInNewTab = () => {
            if (src) window.open(src, "_blank");
        };

        if (type === "video")
            return (<>
                <video src={src} controls
                    style={{ width: "100%", height: "100%", objectFit: "" }}
                    muted
                    playsInline
                    preload="metadata" />;
                {/* <button
                    onClick={handleOpenInNewTab}
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "rgba(0,0,0,0.6)",
                        border: "none",
                        borderRadius: "50%",
                        width: "64px",
                        height: "64px",
                        color: "white",
                        fontSize: "24px",
                        cursor: "pointer",
                    }}
                    title="Play Video"
                >
                    ►
                </button> */}
            </>)
        if (type === "image")
            return <img src={src} alt="Gallery" style={boxStyle} onError={(e) => { e.currentTarget.style.display = 'none'; }} />;
        return null;
    };







    const today = new Date().toLocaleString("en-US", { weekday: "short" }); // e.g., 'Mon'
    const isAvailableToday = personalData?.working_days?.includes(today);


    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);


    const [ratingR, setRatingR] = useState(0);
    const [fullName, setFullName] = useState("");
    const [reviewText, setReviewText] = useState("");

    const handleSubmitReview = async () => {
        if (!fullName || !reviewText || ratingR === 0) {
            alert("Please complete all fields and select a rating ⭐");
            return;
        }

        try {
            await addDoc(collection(db, "parlour_feedback"), {
                full_name: fullName,
                review: reviewText,
                rating: ratingR,
                created_date: Timestamp.now(),
                username: params.id?.toLowerCase(), // 💡 include username if you're filtering by this elsewhere
            });

            alert("Review submitted successfully! ✅");
            setIsModalOpen(false);
            setFullName("");
            setReviewText("");
            setRatingR(0);
        } catch (err) {
            console.error("Error submitting review:", err);
            alert("Something went wrong. Try again.");
        }
    };




    const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
    const [bookingName, setBookingName] = useState("");
    const [bookingPhone, setBookingPhone] = useState("");
    const [bookingMessage, setBookingMessage] = useState("");
    const [selectedService, setSelectedService] = useState("");

    const servicebox = (name) => {
        setIsBookingModalOpen(true)
        setSelectedService(name);
    }


    const handleBookingSubmit = async () => {
        if (!bookingName || !bookingPhone || !bookingMessage) {
            alert("Please fill in all fields.");
            return;
        }

        try {
            await addDoc(collection(db, "booking_request_data"), {
                full_name: bookingName,
                phone_no: bookingPhone,
                message: bookingMessage,
                service_name: selectedService,
                created_date: Timestamp.now(),
                username: params.id?.toLowerCase() || "",
            });

            alert("Booking request sent ✅");
            setIsBookingModalOpen(false);
            setBookingName("");
            setBookingPhone("");
            setBookingMessage("");
        } catch (err) {
            console.error("Booking request failed", err);
            alert("Failed to send. Try again.");
        }
    };




    return (
        <>
            <header class="site">
                <div class="container">
                    <div class="nav">

                        <a class="brand" href="">
                            <img src="assets/d6e7b5f5bb0f6e7cb0f6f7f1c151db7703cacea9.png" alt="Youvati" />
                        </a>


                        <button class="menu-toggle" id="menuToggle" aria-label="Toggle Menu">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>


                        <nav class="pill-nav" id="mainNav">
                            <a class="active" >Portfolio</a>
                            <a style={{ paddingLeft: "15px", }} href={`/${params.id}/service`}>Services</a>
                            {/* <a style={{ paddingLeft: "15px", }} href={`/${params.id}/gallery`}>Gallery</a> */}
                            <Link
                                to={`/${params.id}/gallery`}
                                state={{ galleryItems: personalData.gallery }}
                                style={{ paddingLeft: "15px", }}
                            >
                                Gallery
                            </Link>
                            <Link
                                to={`/${params.id}/certificate`}
                                state={{ galleryItems: personalData.gallery }}
                                style={{ paddingLeft: "15px", }}
                            >
                                Certificate
                            </Link>
                        </nav>
                    </div>
                </div>
            </header>



            <section class="hero">
                <div class="container">
                    <div class="hero-grid">

                        <div class="hero-card">
                            <div class="hero-top">
                                <span class="badge">{personalData?.profession}</span>
                                {/* {personalData?.instagram_username != "" && <a href={personalData?.instagram_username} target="_blank" class="social-icon">
                                    <img src="assets/1982_338.svg" alt="Instagram" style={{ maxWidth: "65%" }} />
                                </a>} */}
                                {personalData?.instagram_username && (<a href={personalData.instagram_username.startsWith("http") ? personalData.instagram_username : `https://instagram.com/${personalData.instagram_username}`} target="_blank" rel="noopener noreferrer" class="social-icon" >  <img src="assets/1982_338.svg" alt="Instagram" style={{ maxWidth: "65%" }} /> </a>)}
                            </div>
                            <span
                                style={{
                                    fontFamily: "Syne, Montserrat, sans-serif",
                                    fontWeight: "700",
                                    fontSize: "54px",
                                    paddingTop: "20px",
                                    color: "#38357A",
                                }}
                            >
                                {personalData?.name
                                    ? personalData.name.charAt(0).toUpperCase() + personalData.name.slice(1)
                                    : ""}
                            </span>
                            <span style={{ color: "#5C5C5C", fontWeight: "600", paddingBottom: "8px", paddingTop: "8px" }}>
                                {parseInt(personalData.experience)}+ Years of Experience
                            </span>

                            <p>{personalData?.bio}

                            </p>
                        </div>



                        <div class="hero-media"
                            style={{ backgroundImage: `url(${personalData?.profile_image})` }}></div>
                    </div>

                    {personalData?.working_ho}

                    {personalData?.working_hours == "null - null" ? <>

                        <div class="info-stripo">

                            <div className="card" style={{ padding: 0, overflow: "hidden" }}>
                                <iframe
                                    title="Location Map"
                                    width="100%"
                                    height="220"
                                    frameBorder="0"
                                    style={{ border: 0 }}
                                    src={`https://www.google.com/maps?q=${encodeURIComponent(
                                        `${personalData?.address || personalData?.city || ""}, ${personalData?.state || ""}`
                                    )}&z=15&output=embed`}
                                    allowFullScreen
                                ></iframe>
                                <div style={{
                                    position: "absolute",
                                    bottom: 8,
                                    left: 12,
                                    color: "#fff",
                                    fontWeight: "600",
                                    textShadow: "0 1px 2px rgba(0,0,0,0.7)",
                                    fontSize: "0.95rem"
                                }}>
                                    {/* 📍 {personalData?.address || "Location unavailable"} */}
                                </div>
                            </div>


                            <div class="card soft-pink">
                                <div class="rating-row">
                                    <div class="col">
                                        <div class="stars" style={{ display: "flex", gap: "6px", paddingBottom: "6px" }}>
                                            <strong>{rating === "NaN" ? "0" : rating}</strong> <img src="assets/1982_386.svg" alt="star"
                                                style={{ verticalAlign: "middle" }} />
                                        </div>
                                        <div class="" style={{ color: "#5C5C5C" }}>{testimonials.length} Reviews</div>
                                    </div>
                                    <div class="avatars">
                                        <img src="assets/review_images.png" alt="A1" />

                                    </div>
                                </div>
                                {/* <div class="cta-block">
                                <a class="btn btn-cta" href="" style={{ padding: "0.45rem 0.4rem" }}>
                                    Contact Now
                                    <img src="assets/1982_412.svg" alt="" />
                                </a>
                            </div> */}
                                <div class="cta-block">
                                    <a
                                        class={`btn btn-cta ${!personalData?.allowWhats_app ? 'disabled' : ''}`}
                                        href={personalData?.allowWhats_app ? `https://wa.me/${personalData.phone_no}` : ""}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            padding: "0.45rem 0.4rem",
                                            pointerEvents: personalData?.allowWhats_app ? "auto" : "none",
                                            opacity: personalData?.allowWhats_app ? 1 : 0.6,
                                            cursor: personalData?.allowWhats_app ? "pointer" : "not-allowed",
                                        }}
                                    >
                                        Contact Now
                                        <img src="assets/1982_412.svg" alt="" />
                                    </a>
                                </div>

                            </div>
                        </div>

                    </> : <>
                        <div class="info-strip">

                            <div className="card soft-green">
                                <div className="schedule">
                                    <div className="kv">
                                        <img src="assets/schedule.png" alt="clock" />
                                        <span style={{ color: "#5C5C5C" }}>{personalData?.working_hours}</span>
                                    </div>


                                </div>

                                <div className="schedule" style={{ marginTop: "14px" }}>
                                    <div className="kv">
                                        <img src="assets/calendar_month.png" alt="calendar" />
                                        <div className="week">
                                            {["S", "M", "T", "W", "T", "F", "S"].map((day, index) => {
                                                const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                                                const fullDay = dayMap[index];
                                                const isWorking = personalData?.working_days?.includes(fullDay);

                                                return (
                                                    <span key={index} className={`day ${isWorking ? "ok" : ""}`}>
                                                        {day}
                                                    </span>
                                                );
                                            })}
                                        </div>

                                    </div>
                                    <br />
                                    <div>
                                        {isAvailableToday && (
                                            <span className="avail">
                                                <img src="assets/1982_378.svg" alt="" width="14" />Available Today
                                            </span>
                                        )}
                                    </div>

                                    {/* <div className="kv">
                                    <img src="assets/1982_374.svg" alt="pin" />
                                    <span style={{ color: "#5C5C5C" }}>{personalData?.city}, {personalData?.state} </span>
                                </div> */}
                                </div>
                            </div>

                            <div className="card" style={{ padding: 0, overflow: "hidden" }}>
                                <iframe
                                    title="Location Map"
                                    width="100%"
                                    height="220"
                                    frameBorder="0"
                                    style={{ border: 0 }}
                                    src={`https://www.google.com/maps?q=${encodeURIComponent(
                                        `${personalData?.address || personalData?.city || ""}, ${personalData?.state || ""}`
                                    )}&z=15&output=embed`}
                                    allowFullScreen
                                ></iframe>
                                <div style={{
                                    position: "absolute",
                                    bottom: 8,
                                    left: 12,
                                    color: "#fff",
                                    fontWeight: "600",
                                    textShadow: "0 1px 2px rgba(0,0,0,0.7)",
                                    fontSize: "0.95rem"
                                }}>
                                    {/* 📍 {personalData?.address || "Location unavailable"} */}
                                </div>
                            </div>


                            <div class="card soft-pink">
                                <div class="rating-row">
                                    <div class="col">
                                        <div class="stars" style={{ display: "flex", gap: "6px", paddingBottom: "6px" }}>
                                            <strong>{rating === "NaN" ? "0" : rating}</strong> <img src="assets/1982_386.svg" alt="star"
                                                style={{ verticalAlign: "middle" }} />
                                        </div>
                                        <div class="" style={{ color: "#5C5C5C" }}>{testimonials.length} Reviews</div>
                                    </div>
                                    <div class="avatars">
                                        <img src="assets/review_images.png" alt="A1" />

                                    </div>
                                </div>
                                {/* <div class="cta-block">
                                <a class="btn btn-cta" href="" style={{ padding: "0.45rem 0.4rem" }}>
                                    Contact Now
                                    <img src="assets/1982_412.svg" alt="" />
                                </a>
                            </div> */}
                                <div class="cta-block">
                                    <a
                                        class={`btn btn-cta ${!personalData?.allowWhats_app ? 'disabled' : ''}`}
                                        href={personalData?.allowWhats_app ? `https://wa.me/${personalData.phone_no}` : ""}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            padding: "0.45rem 0.4rem",
                                            pointerEvents: personalData?.allowWhats_app ? "auto" : "none",
                                            opacity: personalData?.allowWhats_app ? 1 : 0.6,
                                            cursor: personalData?.allowWhats_app ? "pointer" : "not-allowed",
                                        }}
                                    >
                                        Contact Now
                                        <img src="assets/1982_412.svg" alt="" />
                                    </a>
                                </div>

                            </div>
                        </div></>}


                </div>
            </section>


            {/* <section id="stats" class="stats">
                <div class="container">
                    <div class="stats-grid">
                        <div class="stat">
                            <h4>Experience</h4>
                            <p>Years of Experience In the Industry</p>
                            <div class="num" style={{ color: "#AEAAFA" }}> {parseInt(personalData.experience)}+</div>
                        </div>
                        <div class="stat">
                            <h4>Certificates</h4>
                            <p>Of Recognition & Achievements</p>
                            <div class="num" style={{ color: "#AEAAFA" }}>{certificateCount}</div>
                        </div>
                        <div class="stat">
                            <h4>Ratings</h4>
                            <p>Ratings received by Happy Clients</p>
                            <div class="num" style={{ color: "#AEAAFA" }}>{rating === "NaN" ? "0" : rating}</div>
                        </div>
                    </div>
                </div>
            </section> */}


            {personalService?.services?.length > 0 && <section id="services" class="services">
                <div class="container">
                    <div class="row-title">
                        <h2>Product & Services</h2>
                        <Link
                            to={`/${params.id}/service`}
                            state={{ serviceItems: personalService.services }}
                            className="view-link"
                        >
                            View all ➜
                        </Link>
                    </div>


                    <div class="services-carousel-wrapper">
                        <button class="services-btn left">&#10094;</button>

                        <div class="services-carousel">
                            <div class="services-grid">

                                {personalService?.services?.map((e, i) => (
                                    <div class="service-card" style={{ padding: "1rem", justifyContent: "center" }}>
                                        <div class="img-wrapper">
                                            <img src={e.image} alt="image" />
                                            {/* <span class="s-icon">💄</span> */}
                                        </div>
                                        <div class="card-body">
                                            <h3>{e.type}</h3>
                                            <h4 style={{
                                                display: "-webkit-box",
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                color: "#5C5C5C",
                                                fontWeight: "500",
                                            }}>{e.display_name}</h4>
                                            {/* <p style={{
                                                display: "-webkit-box",
                                                WebkitLineClamp: 4,
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                color: "#5C5C5C",
                                                fontWeight: "500",
                                            }}>
                                                {e.details}
                                            </p> */}
                                            <p
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 4,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    color: "#5C5C5C",
                                                    fontWeight: "500",
                                                    lineHeight: "1.4",
                                                    minHeight: "5.6em", // 1.4 * 4 lines
                                                }}
                                            >
                                                {e.details}
                                            </p>

                                            <div class="price">₹{e.amount}</div>
                                            <button className="btn btn-outline" onClick={() => servicebox(e.display_name)}>
                                                Request Booking →
                                            </button>

                                        </div>
                                    </div>

                                ))}

                                {/* <div class="service-card" style={{ padding: "1rem" }}>
                                    <div class="img-wrapper">
                                        <img src="assets/292d471d867805457caca55bd469db0d58706ee8.png" alt="Skin Treatment" />
                                        <span class="s-icon">👩🏻‍🦳</span>
                                    </div>
                                    <div class="card-body">
                                        <h3>Skin</h3>
                                        <h4>Treatment</h4>
                                        <p>
                                            I am a skilled makeup artist with a passion for enhancing natural beauty.
                                            My artistry brings out the best in my clients for various occasions.
                                        </p>
                                        <div class="price">₹999</div>
                                        <a href="" class="btn-outline">Send Message →</a>
                                    </div>
                                </div>


                                <div class="service-card" style={{ padding: "1rem" }}>
                                    <div class="img-wrapper">
                                        <img src="assets/ddabf1596f60bbe8c2ead674cc75ab2b7be41af7.png" alt="Haircut" />
                                        <span class="s-icon">🪮</span>
                                    </div>
                                    <div class="card-body">
                                        <h3>Hair</h3>
                                        <h4>Haircut</h4>
                                        <p>
                                            Capturing the most cherished moments of your special day with a blend of
                                            creativity and expertise to create lasting memories.
                                        </p>
                                        <div class="price">₹2499</div>
                                        <a href="" class="btn-outline">Send Message →</a>
                                    </div>
                                </div>

                                <div class="service-card" style={{ padding: "1rem" }}>
                                    <div class="img-wrapper">
                                        <img src="assets/55c971d5bdf9cff3b094119addbb988c7207a0bc.png" alt="Bridal Makeup" />
                                        <span class="s-icon">💄</span>
                                    </div>
                                    <div class="card-body">
                                        <h3>Bridal</h3>
                                        <h4>Bridal Makeup</h4>
                                        <p>
                                            I am a skilled makeup artist with a passion for enhancing natural beauty.
                                            My artistry brings out the best in my clients for various occasions.
                                        </p>
                                        <div class="price">₹1399</div>
                                        <a href="" class="btn-outline">Send Message →</a>
                                    </div>
                                </div>

                                <div class="service-card" style={{ padding: "1rem" }}>
                                    <div class="img-wrapper">
                                        <img src="assets/292d471d867805457caca55bd469db0d58706ee8.png" alt="Skin Treatment" />
                                        <span class="s-icon">👩🏻‍🦳</span>
                                    </div>
                                    <div class="card-body">
                                        <h3>Skin</h3>
                                        <h4>Treatment</h4>
                                        <p>
                                            I am a skilled makeup artist with a passion for enhancing natural beauty.
                                            My artistry brings out the best in my clients for various occasions.
                                        </p>
                                        <div class="price">₹999</div>
                                        <a href="" class="btn-outline">Send Message →</a>
                                    </div>
                                </div>

                                <div class="service-card" style={{ padding: "1rem" }}>
                                    <div class="img-wrapper">
                                        <img src="assets/ddabf1596f60bbe8c2ead674cc75ab2b7be41af7.png" alt="Haircut" />
                                        <span class="s-icon">🪮</span>
                                    </div>
                                    <div class="card-body">
                                        <h3>Hair</h3>
                                        <h4>Haircut</h4>
                                        <p>
                                            Capturing the most cherished moments of your special day with a blend of
                                            creativity and expertise to create lasting memories.
                                        </p>
                                        <div class="price">₹2499</div>
                                        <a href="" class="btn-outline">Send Message →</a>
                                    </div>
                                </div> */}


                            </div>
                        </div>

                        <button class="services-btn right">&#10095;</button>
                    </div>
                </div>
            </section>}


            {personalData?.gallery?.length > 0 &&
                <section id="gallery" class="gallery">
                    <div class="container">
                        <div class="row-title">
                            <h2>Gallery</h2>
                            {/* <a class="view-link" href="">View all ➜</a> */}
                            {/* <Link
                                to="/gallery"
                                state={{ galleryItems: personalData.gallery }}
                                className="view-link"
                            >
                                View all ➜
                            </Link> */}

                            <Link
                                to={`/${params.id}/gallery`}
                                state={{ galleryItems: personalData.gallery }}
                                className="view-link"
                            >
                                View all ➜
                            </Link>
                        </div>

                        <div class="gallery-wrapper">
                            <button class="gallery-btn left">&#10094;</button>

                            <div class="gallery-track">
                                {personalData?.gallery?.map((item, index) => (
                                    <div class="g-card">
                                        <div class="g-img">
                                            {/* <img src="assets/ba2f05b7fd85ed3cdfa980d5f9f00f13c9acaa74.png" alt="Hair"
                                            style={{ height: "24rem", width: "22rem", objectFit: "cover" }} /> */}
                                            <MediaThumb
                                                item={item}

                                            />
                                        </div>

                                        {/* <div class="g-title">{item.tag}</div> */}
                                    </div>



                                ))}

                                {/* 
                            <div class="g-card">
                                <div class="g-img">
                                    <img src="assets/ba2f05b7fd85ed3cdfa980d5f9f00f13c9acaa74.png" alt="Hair"
                                        style={{ height: "24rem", width: "22rem", objectFit: "cover" }} />
                                </div>

                                <div class="g-title">Hair</div>
                            </div>

                            <div class="g-card">
                                <div class="g-img">
                                    <img src="assets/2e5f4eba0fc23826d3b5d465335423a9587ef181.png" alt="Makeup"
                                        style={{ height: "24rem", width: "22rem", objectFit: "cover" }} />
                                </div>
                                <div class="g-title">Makeup</div>
                            </div>

                            <div class="g-card">
                                <div class="g-img">
                                    <img src="assets/ce8a114484d6f3992dc37d8004500ab32d4b9a35.png" alt="Skin"
                                        style={{ height: "24rem", width: "22rem", objectFit: "cover" }} />
                                </div>
                                <div class="g-title">Skin</div>
                            </div>

                            <div class="g-card">
                                <div class="g-img">
                                    <img src="assets/ba2f05b7fd85ed3cdfa980d5f9f00f13c9acaa74.png" alt="Hair"
                                        style={{ height: "24rem", width: "22rem", objectFit: "cover" }} />
                                </div>

                                <div class="g-title">Hair</div>
                            </div> */}

                            </div>

                            <button class="gallery-btn right">&#10095;</button>
                        </div>




                    </div>
                </section>}




            <section id="testimonials" class="testimonials">
                <div class="container">
                    <div class="t-grid">
                        <div class="t-left">
                            <h2 class="t-title">What Our <span>Customers</span> Say!</h2>
                            <p>If you’ve availed our services, please add a review about your experience</p>
                            <button className="btn btn-outline mt-4" onClick={openModal}>
                                Add Review →
                            </button>

                        </div>

                        <div class="review-section">
                            <div class="review-card" id="reviewCard" style={{}}>
                                <div class="r-head">
                                    <div class="avatar" id="rAvatar">MG</div>
                                    <div class="r-meta">
                                        <div style={{ fontWeight: "700" }} id="rName">Mragank Gaur</div>
                                        <small id="rPhone"></small>
                                    </div>
                                </div>
                                <div class="r-stars" id="rStars">

                                </div>
                                <div class="r-text" id="rText">
                                    At Payal Makeover Hut, they don't just style hair — they create looks that express
                                    your unique personality.
                                </div>
                            </div>

                            <div class="review-nav">
                                <button class="review-btn left" id="prevBtn">&#10094;</button>
                                <button class="review-btn right" id="nextBtn">&#10095;</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div class="strip" style={{ backgroundColor: "#F0EFFE" }}>

                <div class="marquee">

                    <span style={{ display: "flex", alignItems: "anchor-center", marginRight: "60px", fontSize: "21px", }}>Portfolio
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Achievements
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Showcase <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Skills <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Certificates <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Services <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /></span>

                    <span style={{ display: "flex", alignItems: "anchor-center", marginRight: "60px", fontSize: "21px" }}>Portfolio
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Achievements
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Showcase <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Skills <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Certificates <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Services <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /></span>

                    <span style={{ display: "flex", alignItems: "anchor-center", marginRight: "60px", fontSize: "21px" }}>Portfolio
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Achievements
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Showcase <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Skills <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Certificates <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Services <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /></span>

                    <span style={{ display: "flex", alignItems: "anchor-center", marginRight: "60px", fontSize: "21px" }}>Portfolio
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Achievements
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Showcase <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Skills <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Certificates <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Services <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /></span>

                    <span style={{ display: "flex", alignItems: "anchor-center", marginRight: "60px", fontSize: "21px" }}>Portfolio
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Achievements
                        <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Showcase <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /> Skills <img
                            src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Certificates <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} />
                        Services <img src="assets/starr.png" style={{ height: "14px", paddingLeft: "5px", paddingRight: "5px" }} /></span>
                </div>
            </div>




            <footer>
                <div class="container">
                    <div class="f-top">
                        <a class="brand" href=""><img src="assets/youvati_white_logo.png"
                            alt="Youvati" /></a>
                        <div class="f-links">
                            <Link to="/">Home</Link>
                            <Link to="/aboutus">About Us</Link>
                            {/* <Link to="">Privacy Policy</Link> */}
                            <Link to="/contactus">Contact Us</Link>
                        </div>
                        <div class="f-social">
                            {/* <a class="social-ico" href=""><img src="assets/sm3.png"
                                alt="Youvati" /></a> */}
                            <a class="social-ico" href="https://www.linkedin.com/company/youvati/" target="_blank"> <img src="assets/sm2.png"
                                alt="Youvati" /></a>
                            <a class="social-ico" href="https://www.instagram.com/youvatiofficial/?igsh=MXd2aTFkY29laGt5ZQ%3D%3D#" target="_blank" aria-label="X"><img src="assets/sm1.png"
                                alt="Youvati" /></a>
                        </div>
                    </div>
                </div>
            </footer>


            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal">
                        <button className="close-btn" onClick={closeModal}>×</button>
                        <h2>Write a Review</h2>

                        <div className="stars">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    className="star"
                                    onClick={() => setRatingR(star)}
                                    style={{ cursor: "pointer", color: star <= ratingR ? "#fed369" : "#ccc" }}
                                >
                                    ★
                                </span>
                            ))}
                        </div>


                        <label>Your Name</label>
                        <input
                            type="text"
                            placeholder="Your name"
                            className="input"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                        />

                        <label>Write a review</label>
                        <textarea
                            placeholder="Write something..."
                            className="textarea"
                            value={reviewText}
                            onChange={(e) => setReviewText(e.target.value)}
                        />


                        <button className="submit-btn" onClick={handleSubmitReview}>
                            Submit <span style={{ marginLeft: "8px" }}>➜</span>
                        </button>
                    </div>
                </div>
            )}


            {isBookingModalOpen && (
                <div className="modal-overlay">
                    <div className="modal">
                        <button className="close-btn" onClick={() => setIsBookingModalOpen(false)}>×</button>
                        <h2>Request a Booking</h2>

                        <label>Your Name</label>
                        <input
                            type="text"
                            className="input"
                            placeholder="Enter your name"
                            value={bookingName}
                            onChange={(e) => setBookingName(e.target.value)}
                        />

                        <label>Your Contact Number</label>
                        <input
                            type="text"
                            className="input"
                            placeholder="Enter your number"
                            value={bookingPhone}
                            onChange={(e) => setBookingPhone(e.target.value)}
                        />

                        <label>Your Request</label>
                        <textarea
                            className="textarea"
                            placeholder="Write about your request"
                            value={bookingMessage}
                            onChange={(e) => setBookingMessage(e.target.value)}
                        />

                        <button className="submit-btn" onClick={handleBookingSubmit}>
                            Submit <span style={{ marginLeft: "8px" }}>➜</span>
                        </button>
                    </div>
                </div>
            )}




            <style>{`
         :root {
            --primary: #7872F8;
            /* violet */
            --primary-600: #7f76f6;
            --primary-700: #6b60ee;
            --secondary: #232136;
            /* near-black */
            --ink: #3a3a3a;
            --muted: #6b6b6b;
            --bg: #ffffff;
            --bg-soft: #F6F5FA;
            /* soft grey-lavender */
            --chip: #F3E9FF;
            /* soft pill */
            --pink-soft: #FAEAED;
            --green: #2BD095;
            --star: #FED369;
            --border: #D9D7FE;
            --card: #FFFFFF;
            --shadow: 0 8px 28px rgba(35, 33, 54, .08);
            --shadow-soft: 0 10px 30px rgba(147, 142, 250, .18);
            --radius-xl: 28px;
            --radius-2xl: 40px;
        }

        * {
            box-sizing: border-box
        }

        html,
        body {
            height: 100%
        }

        body {
            margin: 0;
            font-family: Montserrat;
            color: var(--ink);
            background: var(--bg);
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }


        .modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: grid;
  place-items: center;
  z-index: 9999;
}

.modal {
  background: white;
  padding: 2rem;
  width: 400px;
  max-width: 95%;
  border-radius: 20px;
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
}

h2 {
  margin-top: 0;
  font-weight: 600;
  font-size: 1.3rem;
}

.stars {
  display: flex;
  gap: 6px;
  margin: 10px 0 20px;
  font-size: 32px;
  color: #ccc;
}

.input,
.textarea {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  border: 1px solid #eee;
  background: #f6f4ff;
  font-size: 1rem;
}

.textarea {
  min-height: 100px;
  resize: vertical;
}

.submit-btn {
  background: #938efa;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  width: 100%;
  font-size: 1rem;
  border-radius: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}


        img {
            max-width: 100%;
            display: block
        }

        .container {
            width: 100%;
            max-width: 1180px;
            margin-inline: auto;
            padding-inline: 20px;
        }

        h1,
        h2,
        h3 {
            line-height: 1.15;
            color: var(--secondary)
        }

        h1 {
            font-family: Syne, Montserrat, sans-serif;
            font-weight: 700;
            font-size: clamp(2rem, 3.2vw + 1rem, 3.5rem);
        }

        h2 {
            font-weight: 700;
            font-size: clamp(1.4rem, 1.2vw + 1rem, 2rem);
            margin: 0;
        }

        a {
            color: white;
            text-decoration: none
        }

        .btn {
            display: inline-flex;
            align-items: center;
            gap: .6rem;
            padding: .85rem 1.4rem;
            border-radius: 999px;
            border: 1.5px solid var(--primary);
            font-weight: 700;
            transition: .25s transform, .25s box-shadow, .25s background;
            box-shadow: none;
        }

        .btn:hover {
            transform: translateY(-1px);
            box-shadow: var(--shadow-soft)
        }

        .btn-primary {
            color: #fff;
            border-color: transparent;
            background: linear-gradient(180deg, var(--primary) 0%, var(--primary-700) 100%);
        }

        .btn-outline {
            color: var(--primary);
            /* background: #fff */
        }

        .badge {
            display: inline-flex;
            align-items: center;
            gap: .5rem;
            background: #EFDAA6;
            color: #5a4c18;
            border-radius: 12px;
            padding: .35rem .7rem;
            font-size: .85rem;
            /* font-weight: 600; */
        }

        /* =============== HEADER =============== */
        /* === HEADER BASE === */
        header.site {
            padding: 16px 0;
         
            top: 0;
            z-index: 100;
            background: rgba(255, 255, 255, 0.96);
            backdrop-filter: blur(8px);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
        }

        /* === NAV CONTAINER === */
        .nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: var(--bg-soft, #f6f5fa);
            border-radius: 64px;
            padding: 5px 24px;
            position: relative;
        }

        /* === LOGO === */
        .brand img {
            height: 26px;
            display: block;
        }

        /* === MENU LINKS === */
        .pill-nav {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 6px;
            border-radius: 999px;
            /* background: #fff;
            box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04); */
            transition: all 0.3s ease;
        }

        .pill-nav a {
            padding: 0.55rem 1rem;
            border-radius: 999px;
            color: #49486b;
            font-weight: 600;
            font-size: 0.95rem;
            transition: 0.3s ease;
        }

        .pill-nav a.active,
        .pill-nav a:hover {
            background: var(--primary, #938EFA);
            color: #fff;
            padding-left: 15px;
        }

        /* === HAMBURGER === */
        .menu-toggle {
            display: none;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 5px;
            width: 42px;
            height: 42px;
            border-radius: 8px;
            background: #fff;
            border: 1.5px solid #e6e6f0;
            cursor: pointer;
            transition: 0.3s;
        }

        .menu-toggle span {
            width: 22px;
            height: 2.5px;
            background: #333;
            border-radius: 2px;
            transition: 0.3s;
        }

        .menu-toggle.active span:nth-child(1) {
            transform: rotate(45deg) translate(5px, 5px);
        }

        .menu-toggle.active span:nth-child(2) {
            opacity: 0;
        }

        .menu-toggle.active span:nth-child(3) {
            transform: rotate(-45deg) translate(5px, -5px);
        }

        /* === MOBILE VIEW FIX === */
        @media (max-width: 900px) {
            .nav {
                padding: 12px 20px;
                justify-content: space-between;
                /* ✅ ensures logo left, icon right */
            }

            .pill-nav {
                position: absolute;
                top: calc(100% + 12px);
                /* opens just below navbar */
                right: 16px;
                width: 200px;
                flex-direction: column;
                align-items: flex-start;
                background: #fff;
                border-radius: 16px;
                padding: 1rem;
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
                opacity: 0;
                transform: translateY(-10px);
                pointer-events: none;
                transition: all 0.3s ease;
            }

            .pill-nav.show {
                opacity: 1;
                transform: translateY(0);
                pointer-events: auto;
            }

            .menu-toggle {
                display: flex;
            }

            .pill-nav a {
                display: block;
                width: 100%;
                padding: 0.6rem 0;
            }
        }



        /* =============== HERO =============== */
        section.hero {
            padding: 28px 0 18px
        }

        .hero-grid {
            display: grid;
            gap: 18px;
            grid-template-columns: 1.15fr .85fr;
        }

        .hero-card {
            /* height: 80%; */
            position: relative;
            overflow: hidden;
            border-radius: var(--radius-2xl);
            background: radial-gradient(100% 120% at 0% 0%, #F6F5FA 0%, #ffffff 48%, #F6F5FA 100%);
            padding: 15px 34px;
            /* box-shadow: var(--shadow); */
            min-height: 360px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        }

        .hero-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            /* margin-bottom: 10px */
        }

        .ig {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 38px;
            height: 38px;
            border-radius: 12px;
            color: var(--primary);
            border: 2px solid var(--primary);
            font-weight: 700
        }

        .hero-card p {
            max-width: 650px;
            font-size: 1rem;
            color: #5C5C5C;
        }

        /* .hero-media {
            border-radius: var(--radius-2xl);
            overflow: hidden;
            height: 100%;
            background: #eee;
            box-shadow: var(--shadow);
        } */

        /* .hero-media {
            border-radius: var(--radius-2xl);
            overflow: hidden;
            height: 27rem;
            width: 30rem;
            background: #eee;
            box-shadow: var(--shadow);
        } */
        .hero-media {
            border-radius: var(--radius-2xl);
            overflow: hidden;
            height: 80%;
            background-color: #F6F5FA;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            /* box-shadow: var(--shadow); */
            min-height: 360px;
        }



        .hero-media img {
            object-fit: cover;
            height: 100%
        }

        .info-stripo{
        display: grid;
        gap: 18px;
        margin-top: 18px;
        grid-template-columns: repeat(2, 1fr);
        }

        /* Info strip under hero */
        .info-strip {
            display: grid;
            gap: 18px;
            margin-top: 18px;
            grid-template-columns: repeat(3, 1fr);
        }


        .card {
            background: var(--card);
            border-radius: var(--radius-2xl);
            /* box-shadow: var(--shadow); */
            padding: 22px;
        }

        .card.soft-green {
            background: #EDF9F4
        }

        .card.soft-pink {
            background-color: #FEEDEF
        }

        .schedule {
            // display: flex;
            gap: 22px;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
        }

        .kv {
            display: flex;
            align-items: center;
            gap: 10px;
            font-weight: 600
        }

        .kv img {
            width: 18px;
            height: 18px
        }

        .week {
            display: flex;
            gap: 8px
        }

        .day {
            width: 36px;
            height: 36px;
            border-radius: 999px;
            display: grid;
            place-items: center;
            font-weight: 700;
            font-size: .9rem;
            border: 2px solid #d9d9df;
            color: #8b8aa7
        }

        .day.ok {
            border-color: var(--green);
            color: #2b2b43
        }

        .avail {
            display: inline-flex;
            align-items: center;
            gap: .5rem;
            padding: .45rem .75rem;
            background: #fff;
            border-radius: 12px;
            color: var(--green);
            font-weight: 600;
            /* border: 1px solid #dff3eb; */
            /* box-shadow: 0 6px 12px rgba(43, 208, 149, .12) */
        }

        .rating-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
            flex-wrap: wrap
        }

        .stars strong {
            font-size: 1.2rem
        }

        .avatars {
            display: flex;
            align-items: center;
            gap: 0;
            margin-left: auto;
            padding: 6px;
            /* border-radius: 999px;
            border: 1px solid #f7c5cb;
            background: #fff; */
        }

        .avatars img {
            width: 111px;
            height: 50px;
            /* object-fit: cover; */
            /* border: 2px solid #1f1d2e */
        }

        .avatars img+img {
            margin-left: -14px
        }

        .cta-block {
            margin-top: 1.5rem
        }

        .btn-cta {
            width: 100%;
            justify-content: center;
            border: 0;
            /* background: linear-gradient(180deg, var(--primary) 0%, #7d6ff2 100%); */
            color: #fff;
            padding: 1rem 1.2rem;
            border-radius: 999px;
            font-weight: 800;
            /* box-shadow: var(--shadow-soft); */
            background-color: #7872F8;
        }

        @media (max-width: 1024px) {
            .hero-grid {
                grid-template-columns: 1fr
            }

            .hero-media {
                order: -1;
                max-height: 420px
            }
        }

        /* =============== STATS =============== */
        section.stats {
            padding: 36px 0
        }

        .stats-grid {
            display: grid;
            gap: 18px;
            grid-template-columns: repeat(3, 1fr);
        }

        .stat {
            border: 2px solid var(--border);
            border-radius: var(--radius-xl);
            padding: 22px 26px;
            background: #fff;
            box-shadow: 0 10px 18px rgba(147, 142, 250, .07)
        }

        .stat h4 {
            margin: 0 0 6px 0;
            font-size: 1rem;
            color: #5b5a77
        }

        .stat p {
            margin: 0 0 12px 0;
            color: #6e6d8f
        }

        .stat .num {
            color: var(--primary);
            font-weight: 800;
            font-size: 3rem;
            line-height: 1
        }

        @media (max-width: 820px) {
            .stats-grid {
                grid-template-columns: 1fr
            }
        }

        /* =============== SECTION TITLE ROWS =============== */
        .row-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 14px;
            margin: 12px 0 22px;
            flex-wrap: wrap
        }

        .view-link {
            display: inline-flex;
            align-items: center;
            gap: .6rem;
            padding: .4rem 1rem;
            border-radius: 999px;
            border: 1.5px solid var(--primary);
            color: var(--primary);
            background: #fff;
            font-weight: 700
        }

        /* =============== GALLERY =============== */
        section.gallery {
            padding: 28px 0 18px
        }

        .gallery-grid {
            display: grid;
            gap: 18px;
            grid-template-columns: repeat(3, 1fr);
        }

        .g-card {
            border: 1px solid var(--border);
            border-radius: 24px;
            background: #fff;
            padding: 14px;
            /* box-shadow: var(--shadow); */
            transition: .2s transform;
        }

        .g-card:hover {
            transform: translateY(-2px)
        }

        .g-img {
            border-radius: 18px;
            overflow: hidden;
            aspect-ratio: 4 / 4.5
        }

        .g-title {
            margin: .65rem .2rem 0;
            font-weight: 700
        }

        @media (max-width: 980px) {
            .gallery-grid {
                grid-template-columns: repeat(2, 1fr)
            }
        }

        @media (max-width: 640px) {
            .gallery-grid {
                grid-template-columns: 1fr
            }
        }

        /* =============== SERVICES =============== */
        section.services {
            padding: 26px 0 8px
        }

        .services-grid {
            margin-top: 9rem;
            display: grid;
            gap: 22px;
            grid-template-columns: repeat(3, 1fr);
        }


        .s-card {
            position: relative;
            border-radius: 40px;
            overflow: hidden;
            background: #fff;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .s-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 16px 35px rgba(147, 142, 250, 0.25);
        }

        /* Top image background */
        .s-top {
            position: relative;
            height: 240px;
            background-size: cover;
            background-position: center;
        }

        /* Floating icon */
        .s-icon {
            position: absolute;
            bottom: -25px;
            left: 50%;
            transform: translateX(-50%);
            background: #fff;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            display: grid;
            place-items: center;
            font-size: 1.4rem;
            color: var(--primary);
            /* box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1); */
            z-index: 2;
        }

        /* Body */
        .s-body {
            padding: 48px 24px 28px;
            text-align: center;
        }

        .s-body h3 {
            margin: 0.4rem 0 0;
            font-size: 1.3rem;
            font-weight: 700;
            color: var(--secondary);
        }

        .s-body h4 {
            margin: 0.2rem 0;
            color: #666;
            font-weight: 600;
        }

        .s-body p {
            font-size: 0.95rem;
            color: #5f5f75;
            margin: 0.8rem 0;
        }

        .s-body .price {
            margin: 0.6rem 0 0.9rem;
            color: var(--primary);
            font-weight: 800;
        }

        /* Purple gradient card variant */
        .s-card.dark {
            background: linear-gradient(145deg, var(--primary-700), #5143e7);
            color: #fff;
        }

        .s-card.dark .s-body h3,
        .s-card.dark .s-body h4,
        .s-card.dark .s-body p {
            color: #f8f8ff;
        }

        .s-card.dark .btn-outline {
            color: #fff;
            border-color: rgba(255, 255, 255, 0.7);
        }

        /* Services grid responsive */
        .services-grid {
            display: grid;
            gap: 24px;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        }



        /* Container */
        .s-card.overlap {
            position: relative;
            background: #f8f6ff;
            border-radius: 32px;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
            text-align: center;
            padding: 100px 24px 32px;
            /* leave space for image overlap */
            transition: transform .3s ease, box-shadow .3s ease;
        }

        .s-card.overlap:hover {
            transform: translateY(-4px);
            box-shadow: 0 16px 35px rgba(147, 142, 250, 0.25);
        }

        /* Image that floats above */
        .s-img {
            position: absolute;
            top: -70px;
            left: 50%;
            transform: translateX(-50%);
            width: 180px;
            height: 180px;
            border-radius: 24px;
            overflow: hidden;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
            background: #fff;
        }

        .s-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        /* Icon that overlaps the image bottom */

        /* Card body text */
        .s-body h3 {
            margin-top: 2rem;
            font-size: 1.3rem;
            font-weight: 700;
            color: var(--secondary);
        }

        .s-body h4 {
            margin: 0.2rem 0;
            color: #666;
            font-weight: 600;
        }

        .s-body p {
            font-size: 0.95rem;
            color: #5f5f75;
            margin: 0.8rem 0;
        }

        .s-body .price {
            margin: 0.6rem 0 0.9rem;
            color: var(--primary);
            font-weight: 800;
        }



        @media (max-width: 1020px) {
            .services-grid {
                grid-template-columns: repeat(2, 1fr)
            }
        }

        @media (max-width: 680px) {
            .services-grid {
                grid-template-columns: 1fr
            }
        }

        /* =============== TESTIMONIALS =============== */
        section.testimonials {
            padding: 42px 0
        }

        .t-grid {
            display: grid;
            gap: 32px;
            align-items: center;
            grid-template-columns: 1.1fr .9fr;
        }

        .t-left p {
            max-width: 500px;
            color: #6b6b86
        }

        .t-title {
            font-family: Syne, Montserrat, sans-serif;
            font-size: clamp(1.8rem, 1.4vw + 1rem, 2.4rem);
            margin: 0 0 .5rem
        }

        .t-title span {
            color: var(--primary)
        }

        .review-card {
            border-radius: 35px 0px 35px 0px;
            background: linear-gradient(135deg, var(--primary) 0%, #6d5ef0 100%);
            color: #fff;
            /* border-radius: 24px; */
            padding: 24px 22px;
            box-shadow: var(--shadow-soft);
        }

        .r-head {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 10px
        }

        .avatar {
            width: 46px;
            height: 46px;
            border-radius: 999px;
            background: #fff;
            color: var(--primary);
            display: grid;
            place-items: center;
            font-weight: 800
        }

        .r-meta small {
            opacity: .9
        }

        .r-stars {
            display: flex;
            gap: 6px;
            margin: 8px 0
        }

        .r-text {
            margin-top: 8px;
            color: #f9f9ff
        }

        @media (max-width: 980px) {
            .t-grid {
                grid-template-columns: 1fr
            }
        }

        /* =============== DIVIDER STRIP =============== */
        .strip {
            margin-top: 36px;
            background: #fbfbff;
            border-top: 1px solid #ecebfd;
            border-bottom: 1px solid #ecebfd;
            color: #6b6a8a;
            white-space: nowrap;
            overflow: hidden
        }

        .marquee {
            display: flex;
            gap: 28px;
            animation: slide 28s linear infinite;
            padding: 12px 0;
        }

        @keyframes slide {
            from {
                transform: translateX(0)
            }

            to {
                transform: translateX(-50%)
            }
        }


        /* small additions only */
        .review-section {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: end;
            gap: 1rem;
        }

        .review-nav {
            display: flex;
            gap: 1rem;
            justify-content: center;
        }

        /* .review-btn {
            background: #fff;
            border: 2px solid #ccc;
            border-radius: 50%;
            width: 44px;
            height: 44px;
            font-size: 1.3rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.3s;
        } */

        .review-btn {
            background: #938efa;
            /* same as active right arrow */
            color: #fff;
            border: none;
            border-radius: 50%;
            width: 44px;
            height: 44px;
            font-size: 1.3rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.3s;
        }

        .review-btn:hover:not(.disabled) {
            background: #7a6efb;
            /* slightly darker hover shade */
        }

        /* ✅ Disabled state */
        .review-btn.disabled {
            background: transparent;
            color: #938efa;
            border: 2px solid #938efa;
            opacity: 0.4;
            cursor: default;
            pointer-events: none;
        }

        .review-btn.right {
            background: var(--primary);
            color: #fff;
            border: none;
        }

        .review-btn:hover {
            transform: scale(1.05);
        }

        /* =============== FOOTER =============== */
        footer {
            padding: 26px 0;
            background: #2E2E2E;
        }

        .f-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
            flex-wrap: wrap
        }

        .f-links {
            display: flex;
            gap: 22px;
            flex-wrap: wrap;
            color: #707090
        }

        .f-social {
            display: flex;
            gap: 36px
        }

        .social-ico {
            width: 25px;
            height: 25px;
            // border-radius: 10px;
            // border: 1.5px solid #e7e6fb;
            display: grid;
            place-items: center;
            color: #444
        }

        /* =============== UTILITIES =============== */
        .chip {
            display: inline-flex;
            align-items: center;
            gap: .45rem;
            padding: .5rem .8rem;
            background: #fff;
            border: 1.5px solid var(--border);
            border-radius: 999px
        }

        .flex {
            display: flex;
            align-items: center
        }

        .gap-8 {
            gap: 8px
        }

        .gap-12 {
            gap: 12px
        }



        /* ======= MOBILE & TABLET RESPONSIVENESS FIX ======= */
        @media (max-width: 1200px) {
            .container {
                padding-inline: 16px;
                max-width: 100%;
            }

            .hero-grid {
                grid-template-columns: 1fr;
            }

            .hero-media {
                order: -1;
                max-height: 420px;
            }

            .info-strip {
                grid-template-columns: 1fr;
            }

            .stats-grid {
                grid-template-columns: 1fr;
            }

            .gallery-grid {
                grid-template-columns: 1fr 1fr;
            }

            .services-grid {
                grid-template-columns: 1fr 1fr;
            }

            .t-grid {
                grid-template-columns: 1fr;
            }
        }

        @media (max-width: 350px) {
            body {
                overflow-x: hidden;
            }

            h1 {
                font-size: 1.8rem;
                line-height: 1.2;
            }

            h2 {
                font-size: 1.4rem;
            }

            .nav {
                flex-direction: column;
                align-items: center;
                text-align: center;
                padding: 12px;
            }

            .pill-nav {
                flex-wrap: wrap;
                justify-content: center;
                gap: 6px;
            }

            .pill-nav a {
                font-size: 0.9rem;
                padding: 0.5rem 0.9rem;
            }

            .hero-card {
                padding: 20px;
                text-align: center;
            }

            .hero-top {
                justify-content: center;
                gap: 10px;
            }

            .hero-card p {
                font-size: 0.95rem;
                margin: 0 auto;
            }

            .hero-media img {
                width: 100%;
                height: auto;
                object-fit: cover;
            }

            .info-strip {
                grid-template-columns: 1fr;
            }

            .schedule {
                flex-direction: column;
                align-items: flex-start;
                gap: 12px;
            }

            .week {
                flex-wrap: wrap;
            }

            .day {
                width: 28px;
                height: 28px;
                font-size: 0.8rem;
            }

            .avatars img {
                width: 36px;
                height: 36px;
            }

            .cta-block .btn-cta {
                font-size: 1rem;
                padding: 0.9rem;
            }

            .stats-grid {
                grid-template-columns: 1fr;
            }

            .gallery-grid {
                grid-template-columns: 1fr;
            }

            .services-grid {
                grid-template-columns: 1fr;
            }

            .review-card {
                margin: 0 auto;
            }

            .t-left {
                text-align: center;
            }

            .f-top {
                flex-direction: column;
                text-align: center;
                gap: 12px;
            }

            .f-links {
                justify-content: center;
            }
        }

        @media (max-width: 480px) {
            .container {
                padding-inline: 10px;
            }

            h1 {
                font-size: 1.5rem;
            }

            p {
                font-size: 0.9rem;
            }

            .nav {
                padding: 10px;
            }

            .pill-nav a {
                font-size: 0.85rem;
                padding: 0.4rem 0.7rem;
            }

            .hero-card {
                padding: 16px;
            }

            .card {
                padding: 16px;
            }

            .num {
                font-size: 2.3rem;
            }

            .btn,
            .view-link {
                font-size: 0.9rem;
                padding: 0.7rem 1rem;
            }

            .btn-cta {
                font-size: 0.95rem;
                padding: 0.8rem;
            }

            .strip .marquee {
                font-size: 0.8rem;
                gap: 20px;
            }

            footer {
                padding: 18px 0;
            }
        }


        .service-card {
            height: 30rem;
            display: flex;
            position: relative;
            background-color: #F0EFFE;
            /* background: linear-gradient(180deg, #f8f6ff 0%, #ffffff 100%); */
            border-radius: 36px;
            /* box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08); */
            text-align: center;
            padding: 110px 24px 36px;
            /* keeps spacing for image overlap */
            overflow: visible;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .card-body {
            display: flex;
            flex-direction: column;
            justify-content: end;
        }

        .service-card:hover {
            transform: translateY(-4px);
            /* box-shadow: 0 16px 35px rgba(147, 142, 250, 0.25); */
        }

        /* Floating image */
        .img-wrapper {
            position: absolute;
            top: -111px;
            left: 50%;
            transform: translateX(-50%);
            width: 301px;
            height: 282px;
            border-radius: 28px;
            /* overflow: hidden; */
            /* box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15); */
            z-index: 2;
        }

        .img-wrapper img {
            width: 120%;
            height: 100%;
            object-fit: cover;
            display: block;
            border-radius: 29px;
        }

        /* Circular icon at image bottom center */
        .icon-overlay {
            position: absolute;
            bottom: -22px;
            left: 50%;
            transform: translateX(-50%);
            width: 54px;
            height: 54px;
            border-radius: 50%;
            background: #4c3eed;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        }

        .icon-overlay img {
            width: 26px;
            height: 26px;
        }

        /* Text content */
        .card-body h3 {
            font-size: 1.4rem;
            font-weight: 700;
            margin-top: 1.6rem;
            margin-bottom: 0.2rem;
            color: #1f1d2e;
        }

        .card-body h4 {
            color: #666;
            margin-bottom: 0.7rem;
        }

        .card-body p {
            color: #555;
            font-size: 0.95rem;
            margin: 0.5rem 0 1rem;
        }

        .price {
            color: #7a6ff7;
            font-weight: 700;
            font-size: 1rem;
            margin-bottom: 1rem;
        }

        .btn-outline {
            display: inline-block;
            border: 1.5px solid #7a6ff7;
            color: #7a6ff7;
            border-radius: 999px;
            padding: 0.6rem 1.2rem;
            font-weight: 600;
            text-decoration: none;
            transition: all 0.25s ease;
        }

        .btn-outline:hover {
            background: #7a6ff7;
            color: #fff;
        }

        /* +++++++++++++++++++++++++++++++++++++Gallery corosual+++++++++++++++++++++++++++++ */
        #gallery {
            padding: 3rem 0;
        }

        .gallery-wrapper {
            position: relative;
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 40px;
            /* padding from both sides */
        }

        .gallery-track {
            display: flex;
            height: 24rem;
            gap: 1.5rem;
            overflow-x: auto;
            scroll-behavior: smooth;
            scrollbar-width: none;
        }

        .gallery-track::-webkit-scrollbar {
            display: none;
        }

        .g-card {
            flex: 0 0 calc((100% - 3rem) / 3);
            /* exactly 3 cards visible (gap * 2 = 3rem) */
            background: #fff;
            border: 2px solid #e4e3ff;
            border-radius: 20px;
            text-align: center;
            padding: 1rem;
            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
            transition: transform 0.3s ease;
        }

        .g-card:hover {
            transform: translateY(-5px);
        }

        .g-img img {
            width: 100%;
            height: 20rem;
            object-fit: cover;
            border-radius: 16px;
        }

        .g-title {
            font-weight: 600;
            margin-top: 0.75rem;
            font-size: 1.1rem;
        }

        .gallery-btn {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: #938efa;
            color: #fff;
            border: none;
            border-radius: 50%;
            width: 48px;
            height: 48px;
            font-size: 1.5rem;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: 0.3s;
        }

        /* 
        .gallery-btn.disabled {
            background: transparent;
            color: #938efa;
            border: 2px solid #938efa;
            cursor: default;
            opacity: 0.4;
            pointer-events: none;
        } */

        .gallery-btn.disabled {
            background: white;
            color: #C2C2C2;
            border: 2px solid #C2C2C2;
            cursor: default;
            /* opacity: 0.4; */
            pointer-events: none;
        }

        .gallery-btn:hover {
            background: #7a6efb;
        }

        .gallery-btn.left {
            left: 0;
            /* on left border of padded area */
        }

        .gallery-btn.right {
            right: 0;
            /* on right border of padded area */
        }

        @media (max-width: 992px) {
            .g-card {
                flex: 0 0 calc((100% - 1.5rem) / 2);
                /* show 2 cards */
            }
        }

        @media (max-width: 600px) {
            .g-card {
                flex: 0 0 100%;
                /* show 1 card */
            }

            .g-img img {
                height: 16rem;
            }

            .gallery-btn {
                width: 40px;
                height: 40px;
                font-size: 1.2rem;
            }
        }

        /* ------------------------------------end gallery corosual--------------------------------------- */

        .services-carousel-wrapper {
            position: relative;
            overflow: hidden;
            padding: 0 40px;
            /* side padding */
        }

        .services-carousel {
            overflow-x: auto;
            scroll-behavior: smooth;
            scrollbar-width: none;
        }

        .services-carousel::-webkit-scrollbar {
            display: none;
        }

        /* Keep existing grid visuals but lay it out inline for scrolling */
        .services-grid {
            display: flex !important;
            gap: 22px;
        }

        .service-card {
            flex: 0 0 calc((100% - 44px) / 3);
            /* exactly 3 visible cards */
        }

        /* Navigation buttons */
        .services-btn {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: var(--primary, #938efa);
            color: #fff;
            border: none;
            border-radius: 50%;
            width: 46px;
            height: 46px;
            font-size: 1.5rem;
            cursor: pointer;
            transition: 0.3s;
            z-index: 10;
        }

        .services-btn.disabled {
            background: white;
            color: #C2C2C2;
            border: 2px solid #C2C2C2;
            cursor: default;
            /* opacity: 0.4; */
            pointer-events: none;
        }

        .services-btn:hover {
            background: #7a6efb;
        }

        .services-btn.left {
            left: 0;
        }

        .services-btn.right {
            right: 0;
        }

        @media (max-width: 992px) {
            .service-card {
                flex: 0 0 calc((100% - 22px) / 2);
            }
        }

        @media (max-width: 600px) {
            .service-card {
                flex: 0 0 100%;
            }

            .services-btn {
                width: 40px;
                height: 40px;
                font-size: 1.2rem;
            }
        }

        .review-btn.disabled {
            background: white;
            color: #C2C2C2;
            border: 2px solid #C2C2C2;
            cursor: default;
            /* opacity: 0.4; */
            pointer-events: none;
        }
        `}</style>

            <script>{`
            `}</script>
        </>

    );
}

export default PortfolioPage;
